module.exports = __webpack_public_path__ + "img/7.d2a2e416.png";